import { Directive, ElementRef, AfterViewInit, Input, ChangeDetectorRef } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Directive({
    selector: 'input[lunaInput], textarea[lunaInput], select[lunaInput]',
    standalone: false
})
export class LunaInputDirective implements AfterViewInit {

    @Input() formControl: AbstractControl;

    controlId: string;
    controlType: string;

    constructor(public _elRef: ElementRef, public _changeDetectionRef: ChangeDetectorRef) {
    }

    ngAfterViewInit() {
        this.getHTMLAttributes();
    }

    setName(name: string): void {
        if (this._elRef.nativeElement.name === '') {
            this._elRef.nativeElement.name = name;
            this._changeDetectionRef.detectChanges();
        }
    }

    public getHTMLAttributes(): void {
        this.controlId = this._elRef.nativeElement.id;
        this.controlType = this._elRef.nativeElement.type ? this._elRef.nativeElement.type : '';
        this._changeDetectionRef.detectChanges();
    }
}
